module.exports = __webpack_public_path__ + "img/5.2fa9c5e4.png";